var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { EventEmitter } from '@angular/core';
import { GroupService } from '../../../services/group-details/group.service';
import { UserService } from '../../../services/user.service';
import { ActionDetails, ActionSource, EventTrackerService, Page, TargetType, UserActionType } from '../../../services/event-tracker/event-tracker.service';
import { AutoGroupSourcesComponent } from './auto-group-sources/auto-group-sources.component';
import { AutoGroupFiltersComponent } from './auto-group-filters/auto-group-filters.component';
import { ValidationHandlerService } from '../../../core/validation-handler.service';
import { AutoGroupFilter, AutoGroupSource, AutoGroupSourceEnum } from '../../../../models/auto-group/auto-group-setting';
import { CacheService } from '../../../services/cache/cache.service';
import { CommonConstant } from '../../../app.constants';
import { CampaignService } from '../../../services/campaign/campaign.service';
import { NewInfluencerGroup } from '../../../../models/auto-group/auto-group-setting';
import { InfluencerGroupsService } from '../../influencer-groups/influencer-groups.service';
var NewGroupSettingsComponent = /** @class */ (function () {
    function NewGroupSettingsComponent(userService, eventTracker, groupService, cacheService, validationService, influencerGroupsService, campaignService) {
        this.userService = userService;
        this.eventTracker = eventTracker;
        this.groupService = groupService;
        this.cacheService = cacheService;
        this.validationService = validationService;
        this.influencerGroupsService = influencerGroupsService;
        this.campaignService = campaignService;
        this.listProject = [];
        this.updateGroupEvent = new EventEmitter();
        this.editOrCreateProjectEvent = new EventEmitter();
        this.beforeSubmitGroupSetting = new EventEmitter();
        this.afterSubmitGroupSetting = new EventEmitter();
        this.identifyRelevantInfluencer = false;
        this.autoGroupSourceList = [];
    }
    NewGroupSettingsComponent.prototype.ngOnInit = function () {
        this.identifyRelevantInfluencer = this.influencerGroup.filters.length > 0 || this.influencerGroup.sources.length > 0;
        this.initAutoGroupSettings();
    };
    NewGroupSettingsComponent.prototype.initAutoGroupSettings = function () {
        var _this = this;
        this.cacheService.get(CommonConstant.NEW_AUTO_GROUP_SOURCE_KEY, this.groupService.getInfluencerGroupSourceTypes()).subscribe(function (res) {
            _this.autoGroupSourceList = res.filter(function (resItem) { return resItem.id !== AutoGroupSourceEnum.BRANDED_SIGNUP; });
        });
        this.cacheService.get(CommonConstant.NEW_AUTO_GROUP_FILTER_KEY, this.groupService.getInfluencerGroupFilterTypes()).subscribe(function (res) {
            _this.supportedFilterTypeOptions = res;
        });
        if (this.listProject && this.listProject.length === 0) {
            this.cacheService.get(CommonConstant.LIST_PROJECT_KEY, this.userService.getAllProjectOfAdvertiser())
                .subscribe(function (res) {
                _this.listProject = res ? res.data : [];
            });
        }
        var companyId = this.userService.getCompanyId();
        this.loadBrandedSignUpConfig(companyId);
        this.cacheService.get("campaign_list_" + companyId, this.campaignService.getCampaignShortListForCompany(companyId)).subscribe(function (res) {
            _this.campaignList = res.map(function (cp) { return ({
                id: cp.id,
                name: cp.name,
                value: cp.name
            }); });
        });
        this.cacheService.get("group_list_" + companyId, this.influencerGroupsService.getInfluencerGroupShortList(companyId)).subscribe(function (res) {
            _this.influencerGroupList = res.map(function (cp) { return ({
                id: cp.id,
                name: cp.name,
                value: cp.name
            }); });
        });
    };
    NewGroupSettingsComponent.prototype.groupSourceDataIsReady = function () {
        return this.autoGroupSourceList.length > 0 && this.supportedFilterTypeOptions && this.influencerGroupList && this.campaignList;
    };
    NewGroupSettingsComponent.prototype.updateGroup = function () {
        this.updateGroupEvent.emit(this.influencerGroup);
    };
    NewGroupSettingsComponent.prototype.toggleIdentifyRelevantInfluencers = function (isToggled) {
        this.sendMixPanelEvent(false, isToggled);
        this.showSourceRequiredErrorMessage = false;
        if (isToggled) {
            this.initGroupSourceAndFilter();
        }
        else {
            this.influencerGroup.filters = [];
            if (!this.brandedSignUpConfig) {
                this.influencerGroup.sources = [];
            }
            else {
                this.influencerGroup.sources = [this.buildBrandedSignSource(this.brandedSignUpConfig)];
            }
        }
    };
    NewGroupSettingsComponent.prototype.loadBrandedSignUpConfig = function (companyId) {
        var _this = this;
        var key = CommonConstant.BRANDED_SIGNUP_CONFIG_KEY + "_" + companyId;
        this.cacheService.get(key, this.userService.getSignUpPageData(companyId)).subscribe(function (res) {
            _this.handleBrandedSignUpResponse(res);
        });
    };
    NewGroupSettingsComponent.prototype.handleBrandedSignUpResponse = function (res) {
        if (!res || (res.influencerGroupId !== this.influencerGroup.id)) {
            return;
        }
        this.brandedSignUpConfig = res;
        this.identifyRelevantInfluencer = true;
        var brandedSignUpSource = this.buildBrandedSignSource(res);
        this.influencerGroup.sources = [brandedSignUpSource].concat(this.influencerGroup.sources);
    };
    NewGroupSettingsComponent.prototype.buildBrandedSignSource = function (brandedSignUp) {
        var brandedSignUpSource = new AutoGroupSource();
        brandedSignUpSource.type = AutoGroupSourceEnum.BRANDED_SIGNUP;
        brandedSignUpSource.sourceValues = [
            {
                id: brandedSignUp.id,
                name: brandedSignUp.brandName,
                type: AutoGroupSourceEnum.BRANDED_SIGNUP
            }
        ];
        return brandedSignUpSource;
    };
    NewGroupSettingsComponent.prototype.initGroupSourceAndFilter = function () {
        if (this.influencerGroup && this.influencerGroup.filters.length === 0) {
            var defaultFilter = new AutoGroupFilter();
            defaultFilter.index = 0;
            this.influencerGroup.filters.push(defaultFilter);
        }
        if (this.influencerGroup && this.influencerGroup.sources.length === 0) {
            var defaultSource = new AutoGroupSource();
            this.influencerGroup.sources.push(defaultSource);
        }
    };
    NewGroupSettingsComponent.prototype.sendMixPanelEvent = function (isUpdateGroupSetting, isToggleOn) {
        var target = {
            id: this.influencerGroup.id,
            name: this.influencerGroup.name,
            type: !isUpdateGroupSetting ? TargetType.GROUP_DISCOVERY : TargetType.INFLUENCER_GROUP
        };
        if (!isUpdateGroupSetting) {
            this.eventTracker.trackUserAction(UserActionType.ACTION, Page.INFLUENCER_GROUP, target, {
                actionDetails: isToggleOn ? ActionDetails.IDENTIFY_RELEVANT_INFLUENCERS_ON : ActionDetails.IDENTIFY_RELEVANT_INFLUENCERS_OFF,
                source: ActionSource.GROUP_SETTINGS,
                action: UserActionType.TOGGLE
            }, undefined, null, null);
        }
        else {
            this.eventTracker.trackUserAction(UserActionType.ACTION, Page.INFLUENCER_GROUP, target, __assign({ actionDetails: ActionDetails.UPDATED_DISCOVERY_FILTERS, source: ActionSource.GROUP_SETTINGS, action: UserActionType.UPDATE }, this.influencerGroup), undefined, null, null);
        }
    };
    NewGroupSettingsComponent.prototype.onSubmit = function () {
        var _this = this;
        this.showSourceRequiredErrorMessage = this.identifyRelevantInfluencer && this.influencerGroup.sources.length === 0;
        var filterErrors = this.autoGroupFilter ? this.autoGroupFilter.validateAllFilters() : [];
        var sourcesErrors = this.autoGroupSource ? this.autoGroupSource.validateAllSources() : [];
        if (filterErrors.length > 0 || sourcesErrors.length > 0) {
            this.validationService.shouldDisplayErrors(true);
            this.validationService.updateErrors(filterErrors.concat(sourcesErrors));
            return;
        }
        if (this.showSourceRequiredErrorMessage) {
            return;
        }
        this.beforeSubmitGroupSetting.emit();
        this.cacheService.clear("InfluencerGroupDetail" + this.influencerGroup.id);
        // call API
        this.groupService.updateInfluencerGroupV2(this.influencerGroup, this.userService.getCompanyId()).subscribe(function (res) {
            // Send mixpanel event
            _this.sendMixPanelEvent(true);
        }, function (error) {
            _this.afterSubmitGroupSetting.emit({
                isError: true
            });
        });
    };
    NewGroupSettingsComponent.prototype.editOrCreateProject = function (project) {
        this.editOrCreateProjectEvent.emit(project);
    };
    NewGroupSettingsComponent.prototype.reloadAndSetSelectedProject = function (selectedProject) {
        var _this = this;
        this.userService.getAllProjectOfAdvertiser().subscribe(function (res) {
            var currentProjectList = Array.isArray(_this.listProject) ? _this.listProject.map(function (p) { return p.id; }) : [];
            var activeProject = selectedProject.id > 0 ? selectedProject : res.data.find(function (p) { return currentProjectList.indexOf(p.id) < 0; });
            if (activeProject) {
                _this.updateSelectedProjectForSource(activeProject);
            }
            _this.listProject = res.data;
        });
    };
    NewGroupSettingsComponent.prototype.updateSelectedProjectForSource = function (project) {
        if (!this.autoGroupSource) {
            return;
        }
        var mentionSource = this.autoGroupSource.autoGroupSourceItemList.find(function (si) { return si.showProjectList; });
        if (mentionSource) {
            mentionSource.updateSelectedProject(project);
        }
    };
    return NewGroupSettingsComponent;
}());
export { NewGroupSettingsComponent };



// WEBPACK FOOTER //
// ./src/app/main/group-details/new-group-settings/new-group-settings.component.ts.pre-build-optimizer.js